"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastPlayerPlayButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const PodcastPlayerPlayButton = ({ isPlaying, audioRef, orderOnPage, setIsEnded, currentTime, duration, isEnded, }) => {
    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        // eslint-disable-next-line sonarjs/no-nested-template-literals
        return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
    };
    const togglePlay = React.useCallback(() => {
        const audio = audioRef.current;
        if (!audio)
            return;
        if (audio.paused) {
            const customEvent = new CustomEvent('pausePlayer', {
                detail: { playedPlayerOrder: orderOnPage },
            });
            window.dispatchEvent(customEvent);
            setIsEnded(false);
            audio.play();
        }
        else {
            audio.pause();
        }
    }, [audioRef, orderOnPage, setIsEnded]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex items-start justify-between", children: (0, jsx_runtime_1.jsxs)("div", { className: "gap-md flex flex-wrap items-center", children: [(0, jsx_runtime_1.jsx)("button", { className: "podcast-player__play-btn border-primary text-icon-primary bg-fill-primary hover:bg-fill-primary-hovered active:bg-fill-primary-pressed py-2xs px-xs flex h-10 w-10 items-center justify-center rounded-2xl border", type: "button", onClick: togglePlay, children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon
                    // eslint-disable-next-line sonarjs/no-nested-template-literals
                    , { 
                        // eslint-disable-next-line sonarjs/no-nested-template-literals
                        name: isPlaying ? 'pause' : isEnded ? 'refresh-outline' : 'play-arrow-outline' }) }), (0, jsx_runtime_1.jsx)("div", { className: "body-sm text-secondary whitespace-nowrap", id: "time-readout", "aria-live": "polite", children: `${formatTime(currentTime)} / ${formatTime(duration)}` })] }) }));
};
exports.PodcastPlayerPlayButton = PodcastPlayerPlayButton;
